import type { MisconceptionDefinition } from '../types';

/** REK — Cijferende vermenigvuldiging & deling (slice 4). */
export const cijferOperatiesMisconceptions: MisconceptionDefinition[] = [
// ── REK-CIJF-KEER specific misconceptions ────────────────────────────
{
  id: 'rek.vermenigvuldigingsfout',
  label: 'Cijferende vermenigvuldigingsfout',
  module: 'Basisrekenen',
  description: 'Leerling maakt een fout in de cijferende vermenigvuldiging (verkeerd tussenproduct, verschoven kolom, verkeerde factor).',
  typicalFamilies: ['REK-CIJF-KEER', 'REK-TAFELS-TOEPASSEN']
}, {
  id: 'rek.nul-placeholder-vergeten',
  label: 'Nul-placeholder vergeten bij staartvermenigvuldiging',
  module: 'Basisrekenen',
  description: 'Bij cijferende vermenigvuldiging met een tweecijferige vermenigvuldiger vergeet leerling de 0 als plaatshouder op de tweede regel (vermenigvuldiging met tientallen), waardoor het tweede tussenproduct in de verkeerde kolommen staat en de optelling fout uitvalt.',
  typicalFamilies: ['REK-CIJF-KEER']
}, {
  id: 'rek.nul-vergeten',
  label: 'Nul in quotiënt vergeten',
  module: 'Basisrekenen',
  description: 'Leerling vergeet de 0 in het quotiënt bij staartdeling wanneer de deler niet in een tussenrest past (bv. 605 ÷ 5 → 11 i.p.v. 121).',
  typicalFamilies: ['REK-CIJF-DEEL']
}];